import { StatDisplayProps } from 'app/agriculture/components/StatDisplay/StatDisplay';

export function statDisplayFormat(value: StatDisplayProps['value'], decimalPlaces: number) {
    if (typeof value !== 'number') return value;
    return value.toFixed(decimalPlaces);
}
